/**
 *  @class
 *  @function EventCountdownTimer
 */
if (!customElements.get('event-countdown-timer')) {
  class EventCountdownTimer extends HTMLElement {
    constructor() {
      super();

      let time = this.dataset.time,
        tarhour = 0,
        tarmin = 0;

      if (time) {
        [tarhour, tarmin] = time.split(':').map(Number);
      }

      this.tarhour = tarhour;
      this.tarmin = tarmin;
      this.offsetMinutes = EventCountdownTimer.parseUtcOffset(this.dataset.utcOffset);
      this.designMode = this.dataset.designMode === 'true';
      this.sectionEl = this.closest('.section-event-countdown-banner');
      this.countDownDate = this._nextOccurrence();
    }

    static parseUtcOffset(offset) {
      const match = String(offset || '').match(/^([+-])(\d{2})(\d{2})$/);
      if (!match) return 0;
      const sign = match[1] === '-' ? -1 : 1;
      return sign * (Number(match[2]) * 60 + Number(match[3]));
    }

    _shopDate(date) {
      return new Date(date.getTime() + this.offsetMinutes * 60 * 1000);
    }

    _shopWallClockToUtc(year, month, day, hour, minute) {
      return Date.UTC(year, month, day, hour, minute, 0, 0) - this.offsetMinutes * 60 * 1000;
    }

    _nextOccurrence() {
      const shopNow = this._shopDate(new Date());
      const year = shopNow.getUTCFullYear();
      const month = shopNow.getUTCMonth();
      const day = shopNow.getUTCDate();
      let targetUtc = this._shopWallClockToUtc(year, month, day, this.tarhour, this.tarmin);

      if (targetUtc <= Date.now()) {
        const nextDay = this._shopDate(new Date(targetUtc + 24 * 60 * 60 * 1000));
        targetUtc = this._shopWallClockToUtc(
          nextDay.getUTCFullYear(),
          nextDay.getUTCMonth(),
          nextDay.getUTCDate(),
          this.tarhour,
          this.tarmin
        );
      }

      return targetUtc;
    }

    _hideSection() {
      if (this.designMode || !this.sectionEl) return;
      this.sectionEl.setAttribute('hidden', '');
    }

    connectedCallback() {
      const hoursEl = this.querySelector('.hours .event-countdown-timer--column--number'),
        minutesEl = this.querySelector('.minutes .event-countdown-timer--column--number'),
        secondsEl = this.querySelector('.seconds .event-countdown-timer--column--number');

      const updateTime = () => {
        const now = Date.now();
        const distance = this.countDownDate - now;

        if (distance <= 0) {
          hoursEl.textContent = minutesEl.textContent = secondsEl.textContent = '00';
          this._hideSection();
          return;
        }

        const hours = Math.floor(distance / (1000 * 60 * 60)),
          minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds = Math.floor((distance % (1000 * 60)) / 1000);

        hoursEl.textContent = EventCountdownTimer.addZero(hours);
        minutesEl.textContent = EventCountdownTimer.addZero(minutes);
        secondsEl.textContent = EventCountdownTimer.addZero(seconds);

        requestAnimationFrame(updateTime);
      };

      requestAnimationFrame(updateTime);
    }

    static addZero(x) {
      return (x < 10 && x >= 0) ? '0' + x : x;
    }
  }
  customElements.define('event-countdown-timer', EventCountdownTimer);
}
